import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '@/pages/home.vue'
import Results from '@/pages/results.vue'
import Profile from '@/pages/profile.vue'
import ManageOpportunities from '@/pages/manageOpportunities.vue'
import SavedSearches from '@/pages/savedSearches.vue'
import Flagged from '@/pages/flagged.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/results',
		name: "results",
		component: Results
	},
	//{
	//    path: '/ManageOpportunities',
	//    name: "ManageOpportunities",
	//    component: ManageOpportunities
	//},
	{
		path: '/profile/:id',
		name: "Profile",
		component: Profile,
		props: true
	},
	{
		path: '/opportunities',
		name: "ManageOpportunities",
		component: ManageOpportunities
	},
	{
		path: '/saved',
		name: "SavedSearches",
		component: SavedSearches
	},
	{
		path: '/flagged',
		name: "Flagged",
		component: Flagged
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
